import { apiFetch } from "@/lib/api";

export type GeneralSettings = {
  id: string;
  general_terms?: string | null;
  payment_terms?: string | null;
  privacy_policy?: string | null;
  expiration_days?: number | null;
  in_progress_to_sent_sla_hours?: number | null;
  created_at?: string;
  updated_at?: string;
};

export const getGeneralSettings = async (): Promise<GeneralSettings> => {
  return apiFetch<GeneralSettings>("/settings/general");
};

export const updateGeneralSettings = async (data: Partial<GeneralSettings>): Promise<GeneralSettings> => {
  return apiFetch<GeneralSettings>("/settings/general", {
    method: "PUT",
    body: JSON.stringify(data),
  });
};
